import React, {
  useMemo,
} from "react";
import { useAppSelector } from "../../api/hooks";
import {
  selectSpreads,
  type ISpread,
} from "../../api/spreadsSlice";
import "./SpreadsCatalogPage.css";
import { SpreadCard } from "../../components/spread/spread";

function pluralizeRu(
  n: number,
  one: string,
  few: string,
  many: string
): string {
  const n10 = n % 10;
  const n100 = n % 100;

  if (
    n10 === 1 &&
    n100 !== 11
  ) {
    return one;
  }

  if (
    n10 >= 2 &&
    n10 <= 4 &&
    (
      n100 < 12 ||
      n100 > 14
    )
  ) {
    return few;
  }

  return many;
}

export const SpreadsCatalogPage:
  React.FC = () => {
    const spreads =
      useAppSelector(
        selectSpreads
      );

    const groups =
      useMemo<
        Array<
          [
            number,
            ISpread[],
          ]
        >
      >(() => {
        const grouped =
          new Map<
            number,
            ISpread[]
          >();

        spreads.forEach(
          (spread) => {
            const group =
              grouped.get(
                spread.cardsCount
              ) ?? [];

            group.push(spread);

            grouped.set(
              spread.cardsCount,
              group
            );
          }
        );

        return Array.from(
          grouped.entries()
        )
          .sort(
            (
              [countA],
              [countB]
            ) =>
              countA -
              countB
          )
          .map(
            ([count, list]) => [
              count,
              [...list].sort(
                (a, b) =>
                  a.name.localeCompare(
                    b.name,
                    "ru"
                  )
              ),
            ]
          );
      }, [spreads]);

    return (
      <div className="spreads-catalog">
        <header className="page-intro">
          <div className="page-intro__eyebrow">
            {spreads.length} раскладов
          </div>

          <h1 className="page-intro__title">
            Каталог раскладов
          </h1>

          <p className="page-intro__text">
            Выберите расклад по глубине
            и количеству позиций.
            Подробная интерпретация
            появится после выбора карт.
          </p>
        </header>

        <div className="spreads-catalog__groups">
          {groups.map(
            ([count, list]) => {
              const title =
                `На ${count} ${pluralizeRu(
                  count,
                  "карту",
                  "карты",
                  "карт"
                )}`;

              return (
                <section
                  key={count}
                  className="spreads-group"
                >
                  <div className="spreads-group__header">
                    <h2 className="spreads-group__title">
                      {title}
                    </h2>

                    <span className="spreads-group__count">
                      {list.length}
                    </span>
                  </div>

                  <div className="spreads-group__grid">
                    {list.map(
                      (spread) => (
                        <SpreadCard
                          key={
                            spread.id
                          }
                          spread={
                            spread
                          }
                          to={`/spreads/${spread.id}`}
                        />
                      )
                    )}
                  </div>
                </section>
              );
            }
          )}
        </div>
      </div>
    );
  };


